import script from "./InputColor.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputColor.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__